module.exports = __webpack_public_path__ + "static/media/SM-MT-2.25f92166.mp3";